import { t } from '@/i18n';
import { FundraisingCampaignStatus } from '@/model';
import { z } from 'zod';

const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
const REQUIRED = t('pages.fundraising_campaign.components.fundraising_campaign_edit_modal.schema.required');

export const modalFormSchema = z
  .object({
    title: z.string().min(1, REQUIRED).max(100, REQUIRED),
    description: z.string().min(1, REQUIRED).max(4000, REQUIRED),
    goal: z.number({ invalid_type_error: REQUIRED }).min(0.1, REQUIRED),
    pix_key: z.string().min(1, REQUIRED),
    status: z.string().min(1, REQUIRED),
    image: z
      .any()
      .refine(
        file => (file && ACCEPTED_IMAGE_TYPES.includes(file.type)) || !file,
        t('pages.fundraising_campaign.components.fundraising_campaign_edit_modal.schema.required_file'),
      ),
    start_date: z
      .string()
      .optional()
      .transform(value => (value === '' ? undefined : value)),
    end_date: z
      .string()
      .optional()
      .transform(value => (value === '' ? undefined : value)),
  })
  .superRefine((values, ctx) => {
    if (values.status === FundraisingCampaignStatus.SCHEDULED && !values?.start_date) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['start_date'],
        message: t('pages.fundraising_campaign.components.fundraising_campaign_edit_modal.schema.required_date'),
      });
    }
    if (values.status === FundraisingCampaignStatus.SCHEDULED && !values?.end_date) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['end_date'],
        message: t('pages.fundraising_campaign.components.fundraising_campaign_edit_modal.schema.required_date'),
      });
    }
  });

export type ModalFormData = z.infer<typeof modalFormSchema>;
